import React from 'react';
import { Button } from 'app/ui_components/tags';

const ResetButton = () => (
  <Button onClick={e => (window.location = window.location.pathname)}>
    Start Over
  </Button>
);

export default ResetButton;
